import configSky from "./config_sky";
import configChampsDev from "./config_champsdev";
import configChampsProd from "./config_champsprod";

const pricingBetaConfigs = {
    "sky-prod": configSky,
    "champs-dev": configChampsDev,
    "champs-prod": configChampsProd
};

const ConfigPath = String(process.env.REACT_APP_CONFIG_PATH || "champs-dev")
    .trim()
    .toLowerCase();

const resultConfig = pricingBetaConfigs[ConfigPath] || configChampsDev;
export default resultConfig;
